<div class="aa-input-general gap-2 flex flex-col">
  @if (label) {
    <mat-label
      class="px-4"
      [ngClass]="
        formControlGeneral?.invalid && (formControlGeneral?.touched || formControlGeneral?.dirty)
          ? 'text-(--comp-input-label-error)'
          : 'text-(--comp-input-label-normal)'
      "
    >
      {{ isRequired(formControlGeneral) ? (label | translate) + '*' : (label | translate) }}
    </mat-label>
  }
  <mat-form-field appearance="outline" class="w-full input-mat-form-field">
    @if (multiple) {
      <mat-select [formControl]="getInputGeneral" [placeholder]="placeholder | translate" multiple>
        @for (item of arrayData; track item) {
          <mat-option
            [value]="inputSelect.value === '' ? item : getNestedProperty(item, inputSelect.value)"
            >{{
              inputSelect.description === ''
                ? item
                : getNestedProperty(item, inputSelect.description)
            }}</mat-option
          >
        }
      </mat-select>
    } @else {
      <mat-select [formControl]="getInputGeneral" [placeholder]="placeholder | translate">
        @for (item of arrayData; track item) {
          <mat-option
            [value]="inputSelect.value === '' ? item : getNestedProperty(item, inputSelect.value)"
            >{{
              inputSelect.description === ''
                ? item
                : getNestedProperty(item, inputSelect.description)
            }}</mat-option
          >
        }
      </mat-select>
    }

    @if (
      formControlGeneral && formControlGeneral.errors && formControlGeneral.hasError('required')
    ) {
      <mat-error>{{ 'inputs.required' | translate }}</mat-error>
    }
    @if (
      formControlGeneral && formControlGeneral.errors && formControlGeneral.errors['errorGeneral']
    ) {
      <mat-error>
        {{ formControlGeneral.errors['errorGeneral'] }}
      </mat-error>
    }
  </mat-form-field>
</div>
